import { render } from "./savings-for-members.vue?vue&type=template&id=73b79689&scoped=true&ts=true"
import script from "./savings-for-members.vue?vue&type=script&lang=ts"
export * from "./savings-for-members.vue?vue&type=script&lang=ts"

import "./savings-for-members.vue?vue&type=style&index=0&id=73b79689&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b79689"]])

export default __exports__